import type { ChannelsTranslation } from './types';

export const channelsAr: ChannelsTranslation = {
  nav: 'القنوات',
  title: 'القنوات',
  description:
    'ردّ على البريد الإلكتروني وواتساب وتيليجرام من صندوق الوارد نفسه الذي تستخدمه للدردشة على موقعك.',
  loading: 'جارٍ تحميل القنوات',
  guide: 'كيف تعمل القنوات',
  brand: 'العلامة التجارية',
  list: 'قنوات {{brand}}',
  forbidden: {
    title: 'لا يمكنك إدارة القنوات',
    description: 'اطلب من مالك مساحة العمل أو مديرها دورًا يسمح بإدارة عمليات الربط.',
  },
  noBrands: {
    title: 'لا توجد علامة تجارية بعد',
    description: 'أضف علامة تجارية أولًا، ثم اربط قنواتها من هنا.',
    action: 'انتقل إلى العلامات التجارية والتثبيت',
  },
  kind: {
    web: 'الدردشة على الموقع',
    email: 'البريد الإلكتروني',
    whatsapp: 'واتساب',
    telegram: 'تيليجرام',
    other: 'قناة أخرى',
  },
  status: {
    connected: 'متصلة',
    needs_attention: 'تحتاج إلى انتباه',
    paused: 'متوقفة مؤقتًا',
  },
  problem: 'رسالة Chatwoot: {{problem}}',
  web: {
    text: 'أداة الدردشة على موقعك.',
    link: 'إعدادات أداة الدردشة',
  },
  // Arabic has six plural forms; the neutral “label: number” reads right for each.
  conversations_zero: 'محادثات هذا الأسبوع: {{count}}',
  conversations_one: 'محادثات هذا الأسبوع: {{count}}',
  conversations_two: 'محادثات هذا الأسبوع: {{count}}',
  conversations_few: 'محادثات هذا الأسبوع: {{count}}',
  conversations_many: 'محادثات هذا الأسبوع: {{count}}',
  conversations_other: 'محادثات هذا الأسبوع: {{count}}',
  lastMessage: 'آخر رسالة: {{time}}',
  noMessages: 'لا رسائل بعد',
  ai: {
    label: 'الذكاء الاصطناعي يردّ هنا',
    hint: 'عند الإيقاف: يردّ فريقك على كل محادثة. عند التشغيل: يردّ الذكاء الاصطناعي أولًا ويحوّل المحادثة إلى فريقك عند الحاجة.',
    on: 'أصبح الذكاء الاصطناعي يردّ أولًا على {{name}}.',
    off: 'أصبح فريقك يردّ على كل محادثة في {{name}}.',
  },
  team: {
    label: 'الفريق',
    none: 'بلا فريق (حسب التوجيه)',
    hidden: 'فريق لا يمكنك رؤيته',
    saved: 'المحادثات الجديدة في {{name}} تذهب الآن إلى {{team}}.',
    cleared: 'التوجيه هو الذي يحدّد الآن من يتلقى المحادثات الجديدة في {{name}}.',
  },
  pause: {
    action: 'إيقاف مؤقت',
    label: 'إيقاف {{name}} مؤقتًا',
    title: 'هل تريد إيقاف {{name}} مؤقتًا؟',
    body: 'تبقى المحادثات الجديدة على هذه القناة في Chatwoot حتى تستأنفها. أما المحادثات الموجودة هنا فتستمر كما هي.',
    confirm: 'إيقاف القناة مؤقتًا',
    done: 'أُوقفت {{name}} مؤقتًا.',
  },
  resume: {
    action: 'استئناف',
    label: 'استئناف {{name}}',
    done: 'عادت {{name}} إلى العمل.',
  },
  unclaimed: {
    text: 'وُجدت في حسابك على Chatwoot.',
    action: 'استخدمها لهذه العلامة التجارية',
    done: 'أصبحت {{name}} تردّ باسم {{brand}}.',
  },
  empty: {
    title: 'لا توجد قنوات بريد إلكتروني أو واتساب أو تيليجرام بعد.',
    description:
      'اربط من هنا بريد الدعم أو رقم واتساب للأعمال أو بوت تيليجرام. أما القنوات التي تضيفها في Chatwoot فتظهر عند البحث عن قنوات جديدة.',
  },
  check: {
    action: 'البحث عن قنوات جديدة',
    busy: 'جارٍ البحث…',
    found_zero: 'قنوات جديدة وُجدت: {{count}}',
    found_one: 'قنوات جديدة وُجدت: {{count}}',
    found_two: 'قنوات جديدة وُجدت: {{count}}',
    found_few: 'قنوات جديدة وُجدت: {{count}}',
    found_many: 'قنوات جديدة وُجدت: {{count}}',
    found_other: 'قنوات جديدة وُجدت: {{count}}',
    none: 'لا توجد قنوات جديدة',
  },
  email: {
    connect: {
      action: 'ربط البريد الإلكتروني',
      title: 'ربط البريد الإلكتروني',
      step: 'الخطوة {{step}} من {{total}}',
      steps: {
        address: 'عنوانك',
        imap: 'البريد الوارد (IMAP)',
        smtp: 'البريد الصادر (SMTP)',
        answering: 'الردّ',
      },
      intros: {
        address: 'العنوان الذي يراسلك عليه عملاؤك.',
        imap: 'يقرأ Chatwoot الرسائل الجديدة من هذا الخادم.',
        smtp: 'تُرسَل ردودك من العنوان نفسه عبر هذا الخادم.',
        answering: 'اختر من يردّ على الرسائل هنا. يمكنك تغيير ذلك لاحقًا من بطاقة القناة.',
      },
      guide: 'كيف تربط البريد الإلكتروني',
      back: 'السابق',
      next: 'التالي',
      submit: 'ربط',
      busy: 'جارٍ التحقق من صندوق بريدك…',
      busyHint: 'يسجّل Chatwoot الدخول إلى صندوق بريدك قبل ربطه. قد يستغرق ذلك لحظات.',
      done: 'رُبط البريد الإلكتروني. ستظهر الرسائل الجديدة في صندوق الوارد.',
    },
    fields: {
      address: 'عنوان الدعم',
      addressHint: 'مثل help@yourshop.com.',
      name: 'الاسم في Studio',
      nameDefault: 'بريد الدعم',
      nameHint: 'لا يرى هذا الاسم إلا فريقك.',
      provider: 'مزوّد البريد',
      providerNone: 'اختر مزوّدك',
      custom: 'مزوّد آخر',
      find: 'اعثر على إعداداتي',
      found: 'ملأنا الإعدادات الخاصة بـ {{provider}}.',
      unknown:
        'لا نعرف إعدادات هذا العنوان. اطلب من مزوّد بريدك خادمَي IMAP وSMTP، وأدخلهما في الخطوات التالية.',
      server: 'الخادم',
      imapServer: 'خادم البريد الوارد',
      smtpServer: 'خادم البريد الصادر',
      port: 'المنفذ',
      imapPort: 'منفذ البريد الوارد',
      smtpPort: 'منفذ البريد الصادر',
      ssl: 'استخدام SSL',
      sslHint: 'أبقِه مفعّلًا ما لم يطلب مزوّدك غير ذلك.',
      login: 'اسم الدخول',
      imapLogin: 'اسم الدخول للبريد الوارد',
      smtpLogin: 'اسم الدخول للبريد الصادر',
      loginHint: 'غالبًا هو عنوان بريدك الإلكتروني كاملًا.',
      imapPassword: 'كلمة مرور البريد الوارد',
      smtpPassword: 'كلمة مرور البريد الصادر',
      security: 'الحماية',
      securityNone: 'بلا حماية',
      noneHint: 'دون حماية تُرسَل كلمة المرور مكشوفة. لا تختر هذا إلا إذا طلبه مزوّدك.',
      sameLogin: 'اسم الدخول وكلمة المرور نفسهما المستخدمان للبريد الوارد',
      show: 'إظهار {{field}}',
      hide: 'إخفاء {{field}}',
    },
    appPassword: {
      title: 'استخدم كلمة مرور للتطبيقات',
      text: 'يطلب مزوّدك كلمة مرور خاصة بالتطبيقات بدلًا من كلمة مرورك المعتادة.',
      link: 'أنشئ كلمة مرور للتطبيقات',
    },
    microsoft: {
      title: 'اربط Microsoft من Chatwoot',
      text: 'لم تعد Microsoft تقبل كلمات المرور في تطبيقات البريد. اربط Outlook أو Microsoft 365 من Chatwoot (الإعدادات ← صناديق الوارد ← البريد الإلكتروني ← Microsoft)، ثم استخدم «البحث عن قنوات جديدة».',
      blocked: 'اختر مزوّدًا آخر لتتابع بكلمة مرور.',
    },
    errors: {
      name: 'أدخل اسمًا لا يزيد على 100 حرف.',
      address: 'أدخل عنوان بريد إلكتروني، مثل help@yourshop.com.',
      server: 'أدخل اسم الخادم، مثل mail.yourshop.com.',
      port: 'أدخل منفذًا من 1 إلى 65535.',
      login: 'أدخل اسم الدخول. غالبًا هو عنوان بريدك الإلكتروني.',
      password: 'أدخل كلمة المرور.',
      newPassword: 'أدخل كلمة المرور الجديدة، أو أبقِ الحالية.',
    },
    settings: {
      action: 'إعدادات البريد',
      label: 'إعدادات البريد لـ {{name}}',
      title: 'إعدادات البريد',
      loading: 'جارٍ تحميل إعدادات البريد',
      general: 'العنوان',
      incoming: 'البريد الوارد (IMAP)',
      outgoing: 'البريد الصادر (SMTP)',
      change: 'تغيير كلمة المرور',
      changeLabel: 'تغيير {{field}}',
      keep: 'إبقاء كلمة المرور الحالية',
      kept: 'تبقى كلمة المرور كما هي.',
      save: 'حفظ',
      busy: 'جارٍ التحقق من صندوق بريدك…',
      done: 'حُفظت إعدادات البريد.',
    },
    fix: {
      action: 'إصلاح تسجيل الدخول',
      label: 'إصلاح تسجيل الدخول لـ {{name}}',
      hint: 'لا يستطيع Chatwoot تسجيل الدخول إلى صندوق البريد هذا، وغالبًا ما يحدث ذلك بعد تغيير كلمة المرور. أدخل كلمة المرور الجديدة.',
    },
  },
  whatsapp: {
    connect: {
      action: 'ربط واتساب',
      title: 'ربط واتساب',
      steps: {
        number: 'رقمك',
        answering: 'الردّ',
        webhook: 'إعداد Webhook لدى Meta',
      },
      intros: {
        number: 'رقم واتساب للأعمال الخاص بك على Cloud API من Meta.',
        answering: 'اختر من يردّ على رسائل واتساب هنا. يمكنك تغيير ذلك لاحقًا من بطاقة القناة.',
        webhook: 'الخطوة الأخيرة: أخبر Meta إلى أين ترسل رسائل عملائك.',
      },
      guide: 'كيف تربط واتساب',
      submit: 'ربط',
      busy: 'جارٍ التحقق مع Meta…',
      busyHint: 'يتحقق Chatwoot من رمز الوصول لدى Meta قبل ربط الرقم. قد يستغرق ذلك لحظات.',
      connected: 'رُبط رقم واتساب. أكمل الآن إعداد Webhook لدى Meta.',
      done: 'رُبط واتساب. ستصل الرسائل إلى صندوق الوارد بعد إعداد Webhook لدى Meta.',
    },
    fields: {
      nameDefault: 'واتساب',
      phoneNumber: 'رقم هاتف النشاط التجاري',
      phoneNumberHint: 'مع علامة + ورمز الدولة، مثل ‎+971 50 123 4567.',
      phoneNumberId: 'معرّف رقم الهاتف (Phone number ID)',
      businessAccountId: 'معرّف حساب واتساب للأعمال (WhatsApp Business Account ID)',
      accessToken: 'رمز الوصول',
      accessTokenHint: 'يُرسَل مباشرة إلى Chatwoot، ولا يحتفظ به Studio.',
    },
    help: {
      title: 'أين تجد هذه البيانات',
      text: 'تجدها لدى Meta في WhatsApp Manager → API setup. استخدم رمز وصول دائمًا صادرًا لمستخدم نظام (System user).',
      link: 'دليل Cloud API من Meta',
    },
    errors: {
      phoneNumber: 'أدخل الرقم مع علامة + ورمز الدولة، مثل ‎+971501234567.',
      phoneNumberId: 'أدخل معرّف رقم الهاتف. يتكوّن من أرقام فقط.',
      businessAccountId: 'أدخل معرّف حساب واتساب للأعمال. يتكوّن من أرقام فقط.',
      accessToken: 'أدخل رمز الوصول. طوله 20 حرفًا على الأقل.',
    },
    setup: {
      action: 'إعداد Meta',
      label: 'إعداد Meta لـ {{name}}',
      title: 'إعداد Webhook لدى Meta',
      loading: 'جارٍ تحميل إعداد Meta',
      instructions:
        'في Meta افتح App Dashboard → WhatsApp → Configuration → Webhook، والصق هاتين القيمتين، ثم اختر «Verify and save»، واشترك بعد ذلك في حقل messages.',
      callbackUrl: 'عنوان الاستدعاء (Callback URL)',
      verifyToken: 'رمز التحقق (Verify token)',
      copy: 'نسخ',
      copyLabel: 'نسخ {{field}}',
      noToken: 'لم يُنشئ Chatwoot رمز التحقق بعد. افتح إعداد Meta مرة أخرى بعد قليل.',
      done: 'تم',
    },
  },
  telegram: {
    connect: {
      action: 'ربط تيليجرام',
      title: 'ربط تيليجرام',
      intro:
        'اربط بوت تيليجرام الخاص بك. تصل الرسائل التي يرسلها الناس إلى البوت إلى صندوق الوارد.',
      guide: 'كيف تربط تيليجرام',
      submit: 'ربط',
      busy: 'جارٍ التحقق مع تيليجرام…',
      done: 'رُبط تيليجرام باسم {{bot}}. ستظهر الرسائل الجديدة في صندوق الوارد.',
      doneUnnamed: 'رُبط تيليجرام. ستظهر الرسائل الجديدة في صندوق الوارد.',
    },
    fields: {
      nameDefault: 'تيليجرام',
      botToken: 'رمز البوت',
      botTokenHint: 'يُرسَل مباشرة إلى Chatwoot، ولا يحتفظ به Studio.',
    },
    help: {
      title: 'احصل على رمز البوت',
      text: 'راسل ‎@BotFather على تيليجرام، وأرسل ‎/newbot، ثم انسخ الرمز الذي يعطيك إياه.',
      link: 'دليل تيليجرام إلى BotFather',
    },
    errors: {
      botToken: 'أدخل الرمز الذي أعطاك إياه ‎@BotFather. يبدو مثل ‎123456789:AAH…‎ دون مسافات.',
    },
  },
  reply: {
    email: 'يُرسَل ردّك بالبريد الإلكتروني.',
    whatsapp: 'يُرسَل ردّك عبر واتساب.',
    telegram: 'يُرسَل ردّك عبر تيليجرام.',
    // Arabic counts: one minute in words; 3–10 take دقائق, the rest دقيقة after the digits.
    minutesLeft_zero: 'يمكنك الردّ لمدة {{count}} دقيقة أخرى.',
    minutesLeft_one: 'يمكنك الردّ لمدة دقيقة واحدة أخرى.',
    minutesLeft_two: 'يمكنك الردّ لمدة {{count}} دقيقة أخرى.',
    minutesLeft_few: 'يمكنك الردّ لمدة {{count}} دقائق أخرى.',
    minutesLeft_many: 'يمكنك الردّ لمدة {{count}} دقيقة أخرى.',
    minutesLeft_other: 'يمكنك الردّ لمدة {{count}} دقيقة أخرى.',
    closed: 'لا يسمح واتساب الآن إلا برسائل القوالب. يمكنك الردّ مجددًا بعد أن يكتب العميل.',
  },
  templates: {
    button: 'قالب',
    open: 'أرسل قالبًا',
    title: 'إرسال قالب واتساب',
    description:
      'بعد 24 ساعة دون رسالة من العميل، لا يوصل واتساب إلا القوالب التي وافقت عليها Meta.',
    loading: 'جارٍ تحميل القوالب',
    search: 'ابحث في القوالب',
    category: {
      UTILITY: 'خدمي',
      MARKETING: 'تسويقي',
      AUTHENTICATION: 'مصادقة',
      other: 'آخر',
    },
    unsupported: {
      not_approved: 'بانتظار موافقة Meta',
      authentication: 'تُرسل أنظمتك الخاصة رموز الاستخدام لمرة واحدة',
      media_header: 'لا يمكن بعدُ إرسال القوالب ذات العنوان بصورة أو فيديو أو مستند من هنا',
    },
    synced: 'آخر تحديث للقوالب {{time}}.',
    syncHint: 'تظهر القوالب الجديدة هنا بعد أن يجلبها Chatwoot من Meta.',
    empty: {
      title: 'لا توجد قوالب معتمدة بعد',
      description:
        'أنشئ قالبًا في WhatsApp Manager لدى Meta. يظهر هنا بعد أن توافق عليه Meta ويجلبه Chatwoot.',
      guide: 'كيف تعمل رسائل القوالب',
    },
    noMatch: 'لا يوجد قالب يطابق «{{query}}».',
    back: 'كل القوالب',
    fields: {
      title: 'املأ القيم',
      none: 'لا يحتاج هذا القالب إلى أي قيمة.',
      header: 'العنوان {{variable}}',
      body: 'الرسالة {{variable}}',
      button: 'الزر «{{label}}»',
      prefilled: 'مُلئت من هذه المحادثة.',
      code: 'الرمز، حتى 15 حرفًا.',
      url: 'يُضاف إلى نهاية رابط الزر.',
    },
    preview: 'معاينة',
    send: 'أرسل القالب',
    // Arabic counts: one in words; 3–10 take قيم, the rest قيمة after the digits.
    missing_zero: 'املأ {{count}} قيمة أخرى للإرسال.',
    missing_one: 'املأ قيمة واحدة أخرى للإرسال.',
    missing_two: 'املأ {{count}} قيمة أخرى للإرسال.',
    missing_few: 'املأ {{count}} قيم أخرى للإرسال.',
    missing_many: 'املأ {{count}} قيمة أخرى للإرسال.',
    missing_other: 'املأ {{count}} قيمة أخرى للإرسال.',
    errors: {
      required: 'املأ هذا الحقل.',
      code: 'لا يتجاوز الرمز 15 حرفًا.',
    },
    sent: 'أُرسل القالب.',
  },
  chatwoot: {
    title: 'لم يستجب Chatwoot',
    description: 'حاول مرة أخرى بعد قليل.',
  },
};
